import { render, staticRenderFns } from "./PurchaseOrderDiscountModal.vue?vue&type=template&id=f2dc6e9a&scoped=true&"
import script from "./PurchaseOrderDiscountModal.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderDiscountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2dc6e9a",
  null
  
)

export default component.exports